import { GETALLHOLIDAY_SUCCESS, GETALLHOLIDAY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getAllHolidayReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETALLHOLIDAY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETALLHOLIDAY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getAllHolidayReducer;
